import React from 'react';
import Helmet from 'react-helmet';
import { PageContainer } from '../../components/Page';
import { navigate } from '@reach/router';
import { withRouteData } from 'react-static';

const PracticeArea = ({ title, slug, image, index, focusAreas}) => {
  const areas = focusAreas.map((focusArea, focusAreaIndex) => (<li key={focusAreaIndex}>{focusArea.text}</li>)).splice(0, 5);
  return (<div className='practiceArea' onClick={() => { navigate(`/practice-areas/${slug}`, { replace: true }); }}>
    <h2>{title}</h2>
    <section className="focusAreas">
      <ul className="list-unstyled">
        {areas}
      </ul>
    </section>
    <section className="angle" style={{ left: `${index * -7}px` }} />
    <div className="cover" style={{ backgroundImage: `url('${image}')` }} />
  </div>);
};

export default withRouteData(({ practiceAreas }) => {
  const areas = [];
  let practiceAreaKeys = Object.keys(practiceAreas || {});
  for (let practiceAreaId in practiceAreas) {
    const practiceArea = practiceAreas[practiceAreaId];
    areas.push((<PracticeArea key={practiceAreaId} index={practiceAreaKeys.indexOf(practiceAreaId)} {...practiceArea} />));
  }
  return (<React.Fragment>
    <Helmet title="Practice Areas" />
    <PageContainer className="no-margin">
      {areas}
    </PageContainer>
  </React.Fragment>);
});
